import * as React from "react";
import { forwardRef } from "react";
const SvgWarning = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M0.75 16.125H17.25L9 1.875L0.75 16.125ZM9.75 13.875H8.25V12.375H9.75V13.875ZM9.75 10.875H8.25V7.875H9.75V10.875Z", fill: "#FFC37D" }));
const ForwardRef = forwardRef(SvgWarning);
export { ForwardRef as ReactComponent };
